<app-esqueleto-tableros [filterWidth]="250">
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span>&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="Periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)">
  </app-filters>

  <div contenido class="workSpaceTab">
    <!-- Zona de Chips - Lado Izquierdo -->
    <div class="zonaChips">

      <div class="togElement">
        <mat-slide-toggle
          labelPosition="before"
          id="anexo3"
          [checked]="tipoAnexo === 'anexo3'"
          (change)="tipoAnexo = 'anexo3'; onTipoAnexoChange()">
          <div class="toggle-label">{{ 'reportes-normativos.anexo3' | translate }}</div>
        </mat-slide-toggle>
      </div>

      <div class="togElement">
        <mat-slide-toggle
          labelPosition="before"
          id="anexo4"
          [checked]="tipoAnexo === 'anexo4'"
          (change)="tipoAnexo = 'anexo4'; onTipoAnexoChange()">
          <div class="toggle-label">{{ 'reportes-normativos.anexo4' | translate }}</div>
        </mat-slide-toggle>
      </div>

      <div class="togElement">
        <mat-slide-toggle
          labelPosition="before"
          id="anexo5"
          [checked]="tipoAnexo === 'anexo5'"
          (change)="tipoAnexo = 'anexo5'; onTipoAnexoChange()">
          <div class="toggle-label">{{ 'reportes-normativos.anexo5' | translate }}</div>
        </mat-slide-toggle>
      </div>

      <div class="togElement">
        <mat-slide-toggle
          labelPosition="before"
          id="anexo6"
          [checked]="tipoAnexo === 'anexo6'"
          (change)="tipoAnexo = 'anexo6'; onTipoAnexoChange()">
          <div class="toggle-label">{{ 'reportes-normativos.anexo6' | translate }}</div>
        </mat-slide-toggle>
      </div>

      <div class="togElement">
        <mat-slide-toggle
          labelPosition="before"
          id="globales"
          [checked]="tipoAnexo === 'globales'"
          (change)="tipoAnexo = 'globales'; onTipoAnexoChange()">
          <div class="toggle-label">{{ 'reportes-normativos.globales' | translate }}</div>
        </mat-slide-toggle>
      </div>

      <div class="togElement">
        <mat-slide-toggle
          labelPosition="before"
          id="activosPonderados"
          [checked]="tipoAnexo === 'activosPonderados'"
          (change)="tipoAnexo = 'activosPonderados'; onTipoAnexoChange()">
          <div class="toggle-label">{{ 'reportes-normativos.activos-ponderados' | translate }}</div>
        </mat-slide-toggle>
      </div>

    </div>

    <!-- Zona de Visualización - Lado Derecho -->
    <div class="zonaVisualizacion">

      @if (!isLoading) {
        <div class="preview-background" [class.preview-background-wide]="tipoAnexo === 'anexo5'">
          @if (tipoAnexo === 'anexo5') {
            <!-- Vista previa del Anexo 5: misma plantilla que genera el Excel, celda por celda. -->
            @if (previewAnexo5.length > 0) {
              <section class="page page-anexo5">
                <div class="pageName">{{ 'reportes-normativos.titulo-anexo5' | translate }}</div>
                <div class="anexo5-grid" [style.grid-template-columns]="anexo5GridCols">
                  <div class="anexo5-logo-wrapper">
                    @if (mostrarLogosGobierno) {
                      <img [src]="LOGO_GOBIERNO_HONDURAS" alt="Logo" class="anexo5-logo">
                      <img [src]="LOGO_CONSEJO_COOPERATIVAS" alt="Logo" class="anexo5-logo">
                    } @else {
                      <img src="/assets/img/logoReporte.png" alt="Logo" class="anexo5-logo">
                    }
                  </div>
                  @for (c of previewAnexo5; track c.row + '_' + c.col) {
                    <div
                      class="anexo5-cell"
                      [style.grid-row]="c.row"
                      [style.grid-column]="c.col + ' / span ' + c.colSpan"
                      [ngStyle]="c.style">{{ c.value }}</div>
                  }
                </div>

                <!-- Sección de Firmas: una línea por firma, con espacio entre cada una -->
                <div class="firmas-preview">
                  @for (firma of firmasPreview; track firma) {
                    <div class="firma-item">
                      <div class="firma-linea"></div>
                      <div class="firma-etiqueta">{{ firma | translate }}</div>
                    </div>
                  }
                </div>
              </section>
            }
          } @else if (tipoAnexo === 'globales') {
            <!-- Vista previa de Indicadores Globales, igual a la hoja del Excel oficial. -->
            @if (datosIndicadoresGlobales.length > 0) {
              <section class="page">
                <div class="pageName">{{ 'reportes-normativos.pagename-globales' | translate }}</div>

                <div class="header-line">{{ 'reportes-normativos.consejo-nacional' | translate }}</div>
                <div class="header-line">{{ 'reportes-normativos.superintendencia' | translate }}</div>
                <div class="header-line">{{ 'reportes-normativos.titulo-globales' | translate }}</div>
                <div class="header-line">{{ cooperativa | uppercase }}</div>
                <div class="header-line header-line-last">{{ 'reportes-normativos.cifras-al' | translate }} {{ fechaEnLetras(fechaInformacion) }}</div>

                <div class="logo-wrapper-sm">
                  @if (mostrarLogosGobierno) {
                    <img [src]="LOGO_GOBIERNO_HONDURAS" alt="Logo" class="report-logo-img-sm">
                    <img [src]="LOGO_CONSEJO_COOPERATIVAS" alt="Logo" class="report-logo-img-sm">
                  } @else {
                    <img src="/assets/img/logoReporte.png" alt="Logo" class="report-logo-img-sm">
                  }
                </div>

                <div class="table-header-row grid-globales">
                  <div class="table-header-cell">{{ 'reportes-normativos.col-indicador' | translate }}</div>
                  <div class="table-header-cell">{{ 'reportes-normativos.col-parametros' | translate }}</div>
                  <div class="table-header-cell">{{ 'reportes-normativos.col-resultado' | translate }}</div>
                  <div class="table-header-cell">{{ 'reportes-normativos.col-rango' | translate }}</div>
                  <div class="table-header-cell">{{ 'reportes-normativos.col-puntaje' | translate }}</div>
                </div>

                @for (dato of datosIndicadoresGlobales; track dato.numero) {
                  @if (dato.nivel === 1) {
                    <div class="table-section-row">
                      {{ dato.numero }} {{ dato.descripcion | uppercase }}
                    </div>
                  } @else {
                    <div class="table-data-row grid-globales">
                      <div class="table-cell text-left">{{ dato.numero }} {{ dato.descripcion }}</div>
                      <div class="table-cell text-center">{{ dato.parametros ?? '' }}</div>
                      <div class="table-cell text-center">{{ dato.resultado ?? '' }}</div>
                      <div class="table-cell text-center">{{ dato.rango ?? '' }}</div>
                      <div class="table-cell text-center">{{ dato.puntaje ?? '' }}</div>
                    </div>
                  }
                }

                <div class="table-summary-row table-summary-row-top">{{ 'reportes-normativos.sumatoria-base' | translate }}</div>
                <div class="table-summary-row">{{ 'reportes-normativos.calificacion-base' | translate }}</div>
                <div class="table-summary-row table-summary-row-bottom">{{ 'reportes-normativos.nivel-riesgo' | translate }}</div>

                <!-- Sección de Firmas: "Elaborado por" / "Autorizado por Gerente General" -->
                <div class="firmas-preview">
                  <div class="firma-item">
                    <div class="firma-linea"></div>
                    <div class="firma-etiqueta">{{ 'reportes-normativos.elaborado-por' | translate }}</div>
                  </div>
                  <div class="firma-item">
                    <div class="firma-linea"></div>
                    <div class="firma-etiqueta">{{ 'reportes-normativos.autorizado-gerente' | translate }}</div>
                  </div>
                </div>
              </section>
            }
          } @else if (tipoAnexo === 'activosPonderados') {
            <!-- Vista previa del Anexo A (Activos Ponderados): solo título y logos,
                 sin cooperativa ni fecha, igual que la hoja oficial. -->
            @if (datosActivosPonderados.length > 0) {
              <section class="page">
                <div class="pageName">{{ 'reportes-normativos.pagename-activos-ponderados' | translate }}</div>

                <div class="blank-row-md"></div>

                <!-- Título y logos van uno al lado del otro (los logos no empujan filas hacia abajo). -->
                <div class="titulo-logo-row">
                  <div class="anexo-title-banner-plano">{{ 'reportes-normativos.titulo-activos-ponderados' | translate }}</div>
                  <div class="logo-wrapper-inline">
                    @if (mostrarLogosGobierno) {
                      <img [src]="LOGO_GOBIERNO_HONDURAS" alt="Logo" class="report-logo-img-sm">
                      <img [src]="LOGO_CONSEJO_COOPERATIVAS" alt="Logo" class="report-logo-img-sm">
                    } @else {
                      <img src="/assets/img/logoReporte.png" alt="Logo" class="report-logo-img-sm">
                    }
                  </div>
                </div>

                @for (dato of datosActivosPonderados; track $index) {
                  @if (dato.tipo === 'titulo') {
                    @if ($index > 0) {
                      <div class="blank-row-sm"></div>
                    }
                    <div class="table-section-row">{{ dato.descripcion }}</div>
                  } @else if (dato.tipo === 'seccion') {
                    <!-- Subencabezado dentro de la sección (ej. "Total activo BG"): código y
                         descripción resaltados (gris, negrita, centrado), el valor va normal. -->
                    <div class="table-data-row grid-activos-ponderados cell-boxed">
                      <div class="table-cell text-center cell-bold seccion-fill">{{ dato.codigo }}</div>
                      <div class="table-cell text-center cell-bold seccion-fill">{{ dato.descripcion }}</div>
                      <div class="table-cell text-right">{{ dato.valor | number:'1.2-2' }}</div>
                    </div>
                  } @else {
                    <!-- La etiqueta va en negrita sin código (Ajuste.../Subtotal.../Total...); el valor
                         solo va en negrita en subtotales y en el total general, no en los ajustes.
                         El total general lleva una fila en blanco antes, como en la hoja oficial. -->
                    @if (dato.tipo === 'total') {
                      <div class="blank-row-sm"></div>
                    }
                    <div class="table-data-row grid-activos-ponderados cell-boxed">
                      @if (dato.codigo) {
                        <div class="table-cell table-cell-wrap" [class.text-center]="!dato.codigoBold" [class.text-left]="dato.codigoBold" [class.cell-bold]="dato.codigoBold">{{ dato.codigo }}</div>
                        <div class="table-cell table-cell-wrap text-left">{{ dato.descripcion }}</div>
                      } @else {
                        <div class="table-cell table-cell-wrap text-left col-span-2 cell-bold">{{ dato.descripcion }}</div>
                      }
                      <div class="table-cell text-right" [class.cell-bold]="dato.tipo === 'destacado' || dato.tipo === 'total'">
                        {{ dato.valor ? (dato.valor | number:'1.2-2') : '' }}
                      </div>
                    </div>
                  }
                }

                <div class="blank-row-sm"></div>
                <div class="blank-row-sm"></div>

                <!-- "Total de Activos Ponderados por Riesgos" al lado de "Capital Institucional Ajustado", igual que en la hoja oficial. -->
                <div class="resumen-capital-wrapper">
                  <div class="resumen-bloque">
                    <div class="table-header-row grid-resumen-ponderados cell-boxed">
                      <div class="table-header-cell">{{ 'reportes-normativos.resumen-titulo' | translate }}</div>
                      <div class="table-header-cell">{{ 'reportes-normativos.col-suma-activos' | translate }}</div>
                      <div class="table-header-cell">{{ 'reportes-normativos.col-activos-ponderados' | translate }}</div>
                    </div>
                    @for (fila of resumenActivosPonderados; track fila.numero) {
                      <div class="table-data-row grid-resumen-ponderados cell-boxed table-data-row-bold">
                        <div class="table-cell text-left">{{ fila.numero }} {{ fila.descripcion }}</div>
                        <div class="table-cell text-right">{{ fila.suma | number:'1.2-2' }}</div>
                        <div class="table-cell text-right">{{ fila.ponderado | number:'1.2-2' }}</div>
                      </div>
                    }
                    <div class="table-data-row grid-resumen-ponderados cell-boxed table-data-row-bold">
                      <div class="table-cell text-left">{{ 'reportes-normativos.totales-label' | translate }}</div>
                      <div class="table-cell text-right">{{ totalResumenSumaActivos | number:'1.2-2' }}</div>
                      <div class="table-cell text-right">{{ totalResumenPonderadoActivos | number:'1.2-2' }}</div>
                    </div>
                  </div>

                  <div class="capital-bloque">
                    <div class="table-header-row cell-boxed">
                      <div class="table-header-cell">{{ 'reportes-normativos.capital-institucional-titulo' | translate }}</div>
                    </div>
                    @for (fila of capitalInstitucional; track $index) {
                      <div class="table-data-row grid-capital-institucional cell-boxed table-data-row-bold">
                        <div class="table-cell text-left">{{ fila.descripcion }}</div>
                        <div class="table-cell text-right">
                          @if (fila.porcentaje) {
                            {{ fila.valor | percent:'1.2-2' }}
                          } @else {
                            {{ fila.valor | number:'1.2-2' }}
                          }
                        </div>
                      </div>
                      <!-- 2 cajas separadas: la primera termina en "Total capital institucional ajustado". -->
                      @if (esFilaTotalCapital(fila.descripcion)) {
                        <div class="blank-row-sm"></div>
                      }
                    }
                  </div>
                </div>

                <div class="blank-row-md"></div>

                <!-- Sección de Firmas: solo 2, "Elaborado por" / "Autorizado por" -->
                <div class="firmas-preview">
                  <div class="firma-item">
                    <div class="firma-linea"></div>
                    <div class="firma-etiqueta">{{ 'reportes-normativos.elaborado-por' | translate }}</div>
                  </div>
                  <div class="firma-item">
                    <div class="firma-linea"></div>
                    <div class="firma-etiqueta">{{ 'reportes-normativos.autorizado-por' | translate }}</div>
                  </div>
                </div>
              </section>
            }
          } @else if (datosAnexo3.length > 0) {
            <section class="page">
              <div class="pageName">{{ tipoAnexo | uppercase }}</div>

              <!-- Fila 1: Vacía -->
              <div class="blank-row-md"></div>

              <!-- Fila 2: ANEXO Dinámico -->
              <div class="anexo-title-banner">
                {{ tituloAnexo }}
              </div>

              <!-- Fila 3: Vacía -->
              <div class="blank-row-sm"></div>

              <!-- Fila 4: Subtítulo Dinámico -->
              <div class="anexo-subtitle-banner">
                {{ subtituloAnexo }}
              </div>

              <!-- Fila 5-6: Logo -->
              <div class="logo-wrapper">
                @if (mostrarLogosGobierno) {
                  <img [src]="LOGO_GOBIERNO_HONDURAS" alt="Logo" class="report-logo-img">
                  <img [src]="LOGO_CONSEJO_COOPERATIVAS" alt="Logo" class="report-logo-img">
                } @else {
                  <img src="/assets/img/logoReporte.png" alt="Logo" class="report-logo-img">
                }
              </div>

              <!-- Fila 7: COOPERATIVA -->
              <div class="field-row">
                <div class="field-label">{{ 'reportes-normativos.cooperativa-label' | translate }}</div>
                <div class="field-value">{{ cooperativa }}</div>
              </div>

              <!-- Fila 8-9: Vacías -->
              <div class="blank-row-md"></div>

              <!-- Fila 10: FECHA INFORMACIÓN -->
              <div class="field-row">
                <div class="field-label">{{ 'reportes-normativos.fecha-informacion-label' | translate }}</div>
                <div class="field-value">{{ fechaConNombreMes(fechaInformacion) }}</div>
              </div>

              <!-- Fila 11: Tipo (solo para Anexos 3 y 4 ANALÍTICOS) -->
              @if (tipoAnexo === 'anexo3' || tipoAnexo === 'anexo4') {
                <div class="tipo-row">
                  <div>{{ 'reportes-normativos.tipo-label' | translate }}</div>
                  <div>{{ 'reportes-normativos.varios-elementos' | translate }}</div>
                </div>

                <!-- Fila 12: (cifras en lempiras) y Nivel -->
                <div class="cifras-row">
                  <div class="cifras-italic">{{ 'reportes-normativos.cifras-lempiras' | translate }}</div>
                  <div></div>
                  <div class="cifras-bold">{{ 'reportes-normativos.nivel-label' | translate }}</div>
                </div>
              } @else {
                <!-- Para Anexos 5 y 6 (CONDENSADOS): solo (cifras en lempiras) -->
                <div class="cifras-row">
                  <div class="cifras-italic">{{ 'reportes-normativos.cifras-lempiras' | translate }}</div>
                  <div></div>
                  <div></div>
                </div>
              }

              <!-- Fila 14: Headers - Diferentes según el tipo de Anexo -->
              @if (tipoAnexo === 'anexo3') {
                <div class="table-header-row grid-anexo3">
                  <div class="table-header-cell">{{ 'reportes-normativos.col-codigo' | translate }}</div>
                  <div class="table-header-cell table-header-cell-wrap">{{ 'reportes-normativos.col-descripcion' | translate }}</div>
                  <div class="table-header-cell">1</div>
                  <div class="table-header-cell">2</div>
                  <div class="table-header-cell">3</div>
                  <div class="table-header-cell">4</div>
                  <div class="table-header-cell">5</div>
                  <div class="table-header-cell">6</div>
                  <div class="table-header-cell">7</div>
                  <div class="table-header-cell">8</div>
                </div>
              } @else if (tipoAnexo === 'anexo4') {
                <div class="table-header-row grid-anexo4">
                  <div class="table-header-cell">{{ 'reportes-normativos.col-codigo' | translate }}</div>
                  <div class="table-header-cell table-header-cell-wrap">{{ 'reportes-normativos.col-descripcion' | translate }}</div>
                  <div class="table-header-cell">1</div>
                  <div class="table-header-cell">2</div>
                  <div class="table-header-cell">3</div>
                  <div class="table-header-cell">4</div>
                  <div class="table-header-cell">5</div>
                  <div class="table-header-cell">6</div>
                  <div class="table-header-cell">7</div>
                </div>
              } @else if (tipoAnexo === 'anexo6') {
                <div class="table-header-row grid-anexo6">
                  <div class="table-header-cell"></div>
                  <div class="table-header-cell">{{ 'reportes-normativos.col-cta' | translate }}</div>
                  <div class="table-header-cell">{{ 'reportes-normativos.col-total' | translate }}</div>
                  <div class="table-header-cell">{{ 'reportes-normativos.col-moneda-nacional' | translate }}</div>
                  <div class="table-header-cell">{{ 'reportes-normativos.col-cta' | translate }}</div>
                  <div class="table-header-cell">{{ 'reportes-normativos.col-moneda-extranjera' | translate }}</div>
                </div>
              }

              <!-- Filas de Datos - Diferentes según el tipo de Anexo -->
              @if (tipoAnexo === 'anexo3') {
                @for (dato of datosAnexo3; track dato) {
                  @if (!anexo3CuentasOcultas.has(dato.codigo)) {
                  <div class="table-data-row grid-anexo3">
                    <div class="table-cell table-cell-wrap">{{ dato.codigo }}</div>
                    <div class="table-cell table-cell-wrap text-left">{{ dato.descripcion }}</div>
                    <div class="table-cell text-right">{{ dato.nivel1 ? (dato.nivel1 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel2 ? (dato.nivel2 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel3 ? (dato.nivel3 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel4 ? (dato.nivel4 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel5 ? (dato.nivel5 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel6 ? (dato.nivel6 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel7 ? (dato.nivel7 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel8 ? (dato.nivel8 | number:'1.2-2') : '' }}</div>
                  </div>
                  }
                }
              } @else if (tipoAnexo === 'anexo4') {
                @for (dato of datosAnexo4; track dato) {
                  @if (!anexo4CuentasOcultas.has(dato.codigo)) {
                  <div class="table-data-row grid-anexo4">
                    <div class="table-cell table-cell-wrap">{{ dato.codigo }}</div>
                    <div class="table-cell table-cell-wrap text-left">{{ dato.descripcion }}</div>
                    <div class="table-cell text-right">{{ dato.nivel1 ? (dato.nivel1 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel2 ? (dato.nivel2 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel3 ? (dato.nivel3 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel4 ? (dato.nivel4 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel5 ? (dato.nivel5 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel6 ? (dato.nivel6 | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.nivel7 ? (dato.nivel7 | number:'1.2-2') : '' }}</div>
                  </div>
                  }
                }
              } @else if (tipoAnexo === 'anexo6') {
                @for (dato of datosAnexo6; track dato) {
                  <div class="table-data-row grid-anexo6">
                    <div class="table-cell">{{ dato.descripcion }}</div>
                    <div class="table-cell text-right">{{ dato.cta ? (dato.cta | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.total ? (dato.total | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.moneda_nacional ? (dato.moneda_nacional | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.cta_extranjera ? (dato.cta_extranjera | number:'1.2-2') : '' }}</div>
                    <div class="table-cell text-right">{{ dato.moneda_extranjera ? (dato.moneda_extranjera | number:'1.2-2') : '' }}</div>
                  </div>
                }
              }

              <!-- 8 Filas en Blanco -->
              @for (i of [0,1,2,3,4,5,6,7]; track i) {
                <div class="blank-row-data"></div>
              }

              <!-- Sección de Firmas: una línea por firma, con espacio entre cada una -->
              <div class="firmas-preview">
                @for (firma of firmasPreview; track firma) {
                  <div class="firma-item">
                    <div class="firma-linea"></div>
                    <div class="firma-etiqueta">{{ firma | translate }}</div>
                  </div>
                }
              </div>
            </section>
          }
        </div>
      } @else {
        <div class="preview-background">
          <div class="page">
            <ngx-skeleton-loader count="5" [theme]="{
              'border-radius': '10px',
              height: '2vh',
              width: '50vw',
            }" />
            <ngx-skeleton-loader [theme]="{
              'border-radius': '15px',
              height: '36vh',
              width: '58vw',
            }" />
          </div>
        </div>
      }
    </div>

    <!-- Botón flotante -->
    <div [ngClass]="{'w3-disabled': isLoading}">
      <button
        mat-fab
        class="fab textoOverFlow"
        (click)="generarAnexo3()"
        [disabled]="isLoading"
        [matTooltip]="(('reportes-normativos.descargar' | translate) + ' ' + tipoAnexo) | uppercase">
        <mat-icon>download</mat-icon>
      </button>
    </div>
  </div>
</app-esqueleto-tableros>
